import { Badge } from '@plush-book/ui';
type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;

const map: Record<string, { tone: BadgeTone; label: string }> = {
  low: { tone: 'admin-green', label: 'Low Risk' },
  medium: { tone: 'admin-amber', label: 'Medium Risk' },
  high: { tone: 'admin-red', label: 'High Risk' },
  manual: { tone: 'admin-violet', label: 'Needs Manual Review' },
};

export function RiskBadge({ level }: { level: keyof typeof map }) {
  const m = map[level] ?? map.low!;
  return (
    <Badge tone={m.tone} withDot>
      {m.label}
    </Badge>
  );
}
